export default "__VITE_ASSET__B1ddvS8I__"